<h5 class="card-title">Recommendations for HR Head</h5>
<ul class="list-group list-group-flush">
  <li class="list-group-item d-flex align-items-center">
    <span class="badge rounded-circle me-2" style="background:#EB5757">&nbsp;</span>
    Conduct a survey for Team 1 & 2
  </li>
  <li class="list-group-item d-flex align-items-center">
    <span class="badge rounded-circle me-2" style="background:#F2994A">&nbsp;</span>
    Initiate training for middle managers
  </li>
  <li class="list-group-item d-flex align-items-center">
    <span class="badge rounded-circle me-2" style="background:#27AE60">&nbsp;</span>
    Recognize high-performing departments
  </li>
</ul>
